module.exports = __webpack_public_path__ + "media/packs/images/flags/GG-b13e874305b529d66aafcb6a6dace6e5.svg";